module.exports = __webpack_public_path__ + "static/img/u-connect-reg-section-3-backgroud.e18ae19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u-connect-reg-section-3-backgroud.png
// module id = Q+hj
// module chunks = 1